<template>
  <div class="panelbox">
    <LeftPannel
      :image="this.$store.state.user.image"
      :cname="this.$store.state.user.cname"
    />
    <div
      :class="
        type == 'admin' ? 'right-panel' : 'right-panel staff-section-page'
      "
    >
      <div class="header">
        <CommonHeader
          v-if="type == 'admin'"
          title="Edit Attendance"
          :name="this.$store.state.user.name"
        />
        <staff-header v-else title="Edit Attendance"></staff-header>
      </div>
      <div class="content-page admin-new-attendance-page">
        <div class="fullrow">
          <div class="row">
            <div class="col-12">
              <div class="back-button-setup">
                <router-link :to="{ name: 'AttendanceList' }">
                  <img
                    src="../../assets/images/back-left-arrow.png"
                    alt="&laquo;"
                  />Back
                </router-link>
              </div>
            </div>
            <div class="col-12">
              <div class="common-white-shadow-background">
                <div class="new-attendance-form-setup">
                  <form class="form-box" @submit.prevent="OnStaffSubmit">
                    <div class="staffname-div">
                      <label for="staffname">Staff Name</label>
                      <select
                        v-model="staffid"
                        name="staffname"
                        id="staffname"
                        required
                      >
                        <option value="" selected>Choose one</option>
                        <option
                          v-for="data in names"
                          :value="data.id"
                          :key="data.id"
                        >
                          {{ data.name }}
                        </option>
                      </select>
                      <p style="color: red">{{ errors.staffid }}</p>
                    </div>
                    <div>
                      <label for="checkinout">Check in/ Out Date</label>
                      <input
                        type="date"
                        name="checkinout"
                        class="checkindate"
                        placeholder="Checkin Date"
                        v-model="date"
                        :max="date"
                        required
                      />
                      <p style="color: red">{{ errors.date }}</p>
                    </div>
                    <div>
                      <label for="checkintime">Check in Time</label>
                      <input
                        type="time"
                        name="checkintime"
                        class="checkintime"
                        v-model="checkin"
                        required
                      />
                      <p style="color: red">{{ errors.checkin }}</p>
                    </div>
                    <div>
                      <label for="checkouttime">Check Out Time</label>
                      <input
                        type="time"
                        name="checkouttime"
                        class="checkintime"
                        v-model="checkout"
                        required
                      />
                      <p style="color: red">{{ errors.checkout }}</p>
                    </div>
                    <div class="attendance-form-submit">
                      <input
                        type="submit"
                        class="yellow-button"
                        value="Update"
                        @click="OnStaffSubmit"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CommonFooter />
    </div>
  </div>
</template>

<script>
import LeftPannel from "../../components/admin/LeftPannel.vue";
import CommonHeader from "../../components/admin/CommonHeader.vue";
import CommonFooter from "../../components/CommonFooter.vue";
import StaffHeader from "../../components/user/CommonHeader.vue";
import axios from "axios";
import base_url from "../../base_url.js";

export default {
  components: {
    LeftPannel,
    CommonHeader,
    CommonFooter,
    StaffHeader,
  },
  data() {
    return {
      id: this.$route.params.id,
      name: "",
      names: [],
      date: new Date().toISOString().substr(0, 10),
      staffid: "",
      checkin: "",
      checkout: "",
      errors: [],
      type: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("type") == "staff") {
      if (localStorage.getItem("permission").includes("AttendanceList")) {
        next();
      } else {
        next({ name: "staff_dashboard" });
      }
    } else {
      next();
    }
  },
  created() {
    this.id = this.$route.query.id;
   
    this.type = localStorage.getItem("type");
    axios
      .post(`${base_url}/user`, {
        headers: { token: localStorage.getItem("token") },
        type: localStorage.getItem("type"),
      })
      .then((res) => {
        this.$store.state.user = res.data.user;
        this.getName();
        this.fetchAttendanceData();
      });
  },
  methods: {
    async getName() {
      const response = await axios.post(
        `${base_url}/staffsfortrack/${this.$store.state.user.id}`
      );
      this.names = response.data;
    },
    async fetchAttendanceData() {
      this.id = this.$route.query.id;
     
      if (this.id) {
        const response = await axios.get(`${base_url}/attendance/${this.id}`);
        const attendance = response.data;

        this.staffid = attendance.staffid;
        this.date = new Date(attendance.date).toISOString().split("T")[0];
        this.checkin = attendance.checkin;
        this.checkout = attendance.checkout;
       
      }
    },
    async OnStaffSubmit() {
      
      this.errors = [];
      if (!this.staffid) {
        this.errors["staffid"] = "Staff Name is required";
      }
      if (!this.date) {
        this.errors["date"] = "Date is required";
      }
      if (!this.checkin) {
        this.errors["checkin"] = "Check In Time is required";
      }
      if (!this.checkout) {
        this.errors["checkout"] = "Check Out Time is required";
      }

      if (
        !this.errors["staffid"] &&
        !this.errors["date"] &&
        !this.errors["checkin"] &&
        !this.errors["checkout"]
      ) {
        this.id = this.$route.query.id;
       
        try {
          const res = await axios.put(`${base_url}/attendance/${this.id}`, {
            staffid: this.staffid,
            date: this.date,
            checkin: this.checkin,
            checkout: this.checkout,
            isCheckout: this.checkout === "" ? "No" : "Yes",
            admin_id: this.$store.state.user.id,
          });
        
          if (res.data.message) {
            this.$notify({
              title: "<b>Attendance</b> updated successfully!",
              type: "success",
            });
            this.$router.push({ name: "AttendanceList" });
          } else {
            // Handle cases where response does not have a message
            console.error("Unexpected server response:", res.data);
            this.$notify({
              title: "Update Failed",
              message: res.data.error || "An unexpected error occurred.",
              type: "error",
            });
          }
        } catch (error) {
          console.error("Request error:", error);
          this.$notify({
            title: "Update Failed",
            message: "An error occurred while updating attendance.",
            type: "error",
          });
        }
      }
    },
  },
};
</script>

<style>
/* Add your specific styles here */
</style>
